import Navigation from "../components/javascripts/Navigation"

export const Now = () => {
    return (
        <>
            <Navigation/>
            <h1>Now</h1>
            <p>What I'm doing now in case we haven't met in awhile</p>
        </>
    )
}